// @flow

import styled from 'styled-components';
import type { Theme } from '../../../../types';

export const TileSelect = styled<any, Theme>('section')`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
`;

export default null;
